import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=3bfaeb0e"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=3bfaeb0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports